import {
  DiscontinuationStatus,
  ProductGroupBase,
  Supplier,
  SupplierItemAssortmentTag,
} from '@retail/products/types';
import { UserName } from './AssortmentPrices';
import { CentralAssortmentItemDTO } from '../dto';
import { ItemPriority } from '..';
import { dateFromString } from '@retail/utils';
import { AssortmentItemBase } from './AssortmentItemBase';

interface CentralAssortmentItemProps extends AssortmentItemBase {
  inAssortment: boolean;
  mainSupplierName?: string;
  assortmentTags: SupplierItemAssortmentTag[];
  createdBy?: UserName;
}

export class CentralAssortmentItem {
  mgSupplierItemId: number;
  inAssortment: boolean;
  mgItemNumber: number;
  finfoNumber?: number;
  nobbNumber?: number;
  primaryText: string;
  secondaryText?: string;
  supplier: Supplier;
  mainSupplierName?: string;
  productGroup: ProductGroupBase;
  primaryGtin?: string;
  priority: ItemPriority;
  assortmentTags: SupplierItemAssortmentTag[];
  discontinuationStatus?: DiscontinuationStatus;
  discontinuationDate?: Date;
  createdBy?: UserName;

  constructor({
    mgSupplierItemId,
    inAssortment,
    mgItemNumber,
    finfoNumber,
    nobbNumber,
    primaryText,
    secondaryText,
    supplier,
    mainSupplierName,
    productGroup,
    primaryGtin,
    priority,
    assortmentTags,
    discontinuationStatus,
    discontinuationDate,
    createdBy,
  }: CentralAssortmentItemProps) {
    this.mgSupplierItemId = mgSupplierItemId;
    this.inAssortment = inAssortment;
    this.mgItemNumber = mgItemNumber;
    this.finfoNumber = finfoNumber;
    this.nobbNumber = nobbNumber;
    this.primaryText = primaryText;
    this.secondaryText = secondaryText;
    this.supplier = supplier;
    this.mainSupplierName = mainSupplierName;
    this.productGroup = productGroup;
    this.primaryGtin = primaryGtin;
    this.priority = priority;
    this.assortmentTags = assortmentTags;
    this.discontinuationStatus = discontinuationStatus;
    this.discontinuationDate = discontinuationDate;
    this.createdBy = createdBy;
  }

  static fromDto = (dto: CentralAssortmentItemDTO): CentralAssortmentItem =>
    new CentralAssortmentItem({
      mgSupplierItemId: dto.mgSupplierItemId,
      inAssortment: dto.inAssortment,
      mgItemNumber: dto.mgItemNumber,
      finfoNumber: dto.finfoNumber,
      nobbNumber: dto.nobbNumber,
      primaryText: dto.primaryText,
      secondaryText: dto.secondaryText,
      supplier: Supplier.fromDto({ id: dto.supplierNumber, name: dto.supplierName }),
      mainSupplierName: dto.mainSupplierName,
      productGroup: ProductGroupBase.fromDto({
        name: dto.productGroupName,
        groupNumber: dto.productGroupNumber,
      }),
      primaryGtin: dto.primaryGtin,
      priority: {
        prioritised: dto.priority === 'TEN',
        validFrom: new Date(dto.priorityValidFrom),
        validTo: dateFromString(dto.priorityValidTo),
      },
      assortmentTags: dto.assortmentTags
        ? dto.assortmentTags.map(SupplierItemAssortmentTag.fromDto)
        : [],
      discontinuationStatus: dto.discontinuationStatus,
      discontinuationDate: dateFromString(dto.discontinuationDate),
      createdBy: dto.createdBy,
    });
}

export interface ExportCentralAssortmentItems {
  mgSupplierItemId: number;
  inAssortment: boolean;
  mgItemNumber: number;
  finfoNumber?: number;
  nobbNumber?: number;
  primaryText: string;
  secondaryText?: string;
  supplier: Supplier;
  productGroup: ProductGroupBase;
  primaryGtin?: string;
  priority: ItemPriority;
  assortmentTag?: string;
  tagFrom?: Date;
  tagTo?: Date;
  discontinuationStatus?: DiscontinuationStatus;
  discontinuationDate?: Date;
  createdBy?: UserName;
}
